import React from "react";
import axios from "axios";
import { useState, useEffect, useContext } from "react";
import SglContext from "../SglContext";
import indicator_icon from "../images/Indicator.gif";
import "../forgotPasswordForm/forgotPasswordForm.css";
import PasswordStrengthMeter from "../common/PasswordStrengthMeter"
import { useNavigate } from 'react-router-dom';


export default function UpdatePasswordForm() {
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [continueUrl, setContinueUrl] = useState("/");
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();


  const Sgl = useContext(SglContext);

  //API END POINTS
  const sgl_webservice_process_password_verification = Sgl.sglApiUrl + "/iphone.php/webservice/ProcessUpdatePassword";
  const sgl_webservice_skip_update_password = Sgl.sglApiUrl + "/iphone.php/webservice/SkipUpdatePassword";
  const user_info_url = Sgl.nestApiUrl + '/users/getLoggedInUser';

  useEffect(() => {
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    let sgl_plugin_error_message = document.getElementById(
      "sgl-plugin-error-message"
    );
    let sgl_plugin_success_message = document.getElementById(
      "sgl-plugin-success-message"
    );


    axios
      .all([
        axios.get(user_info_url),
      ])
      .then(
        axios.spread((response) => {
          Sgl.checkLoginOnSGL()
          if(response.data.user && response.data.user != null){
            setLoading(false);
            setUserData(response.data.user)
            sgl_plugin_form.style.display = "block";
            sgl_plugin_success_message.style.display = "none";
            sgl_plugin_error_message.style.display = "none";
          } else {
            sgl_plugin_form.innerHTML = "";
            sgl_plugin_form.style.display = "none";
            sgl_plugin_success_message.style.display = "none";
            sgl_plugin_error_message.innerHTML = response.data.message;
            sgl_plugin_error_message.style.display = "block";
          }
        })
      );
  }, []);

  let handlePasswordChange = event => {
    setPassword(event.target.value)
  } 

  let handleConfirmPasswordChange = event => {
    setConfirmPassword(event.target.value)
  }

  let confirmPasswordMatch = () => {
    let pass = document.getElementById('pass');
    let conf_pass = document.getElementById('conf_pass');
    let errorContainer = document.getElementById('reg_error_summary');

    if ( pass.value == '' || conf_pass.value == '' ) {
      errorContainer.innerHTML = "Please enter password and confirm password.";
      errorContainer.style.display = "block";
      return false;
    } else if ( pass.value != conf_pass.value ) {
      errorContainer.innerHTML = "The passwords you entered do not match.";
      errorContainer.style.display = "block";
      return false;
    } else {
      errorContainer.innerHTML = "";
      errorContainer.style.display = "none";

      return true;
    }
  }

  let skipUpdatePassword = () => {
    axios.get(sgl_webservice_skip_update_password)
    .then((response) => {
      debugger;
      if ( response.data.verify_mobile_url && response.data.verify_mobile_url != "" ) {
        navigate( response.data.verify_mobile_url );
      } else if ( response.data.referer && response.data.referer != "" && response.data.referer != "https://" + window.location.hostname + "/update-password" ) {
        navigate( response.data.referer );
      } else {
        var login_referrer = localStorage.getItem('login_referrer');
        localStorage.removeItem("login_referrer");
        if( login_referrer && login_referrer != "" && login_referrer != "https://" + window.location.hostname + "/update-password" ){
          navigate( login_referrer);
        }else{
          navigate( "/" );
        }
      }
   });
  }

  let processUpdatePassword = () => {
    if (! confirmPasswordMatch()) {
      return
    }
    let sgl_plugin_form = document.getElementById('sgl-plugin-form');
    let sgl_plugin_error_message = document.getElementById('sgl-plugin-error-message');
    let sgl_plugin_success_message = document.getElementById('sgl-plugin-success-message');
    let errorContainer = document.getElementById('reg_error_summary');

    let pass = document.getElementById('pass');
    let conf_pass = document.getElementById('conf_pass');

    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";

    const params = new URLSearchParams();
    params.append('pass', pass.value);
    params.append('conf_pass', conf_pass.value);
    params.append('customer_id', Sgl.company_id);

    axios.post(sgl_webservice_process_password_verification, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }    
    })
    .then((response) => {
      if(response.data.status){
        sgl_plugin_form.innerHTML = "";
        sgl_plugin_form.style.display = "none";
        sgl_plugin_success_message.style.display = "block";

        if ( response.data.verify_mobile_url && response.data.verify_mobile_url != "" ) {
          setContinueUrl( response.data.verify_mobile_url );
        } else if ( response.data.referer && response.data.referer != "" && response.data.referer != "https://" + window.location.hostname + "/update-password" ) {
          setContinueUrl( response.data.referer );
        } else {
          var login_referrer = localStorage.getItem('login_referrer');
          localStorage.removeItem("login_referrer");
          if ( login_referrer && login_referrer != "" && login_referrer != "https://" + window.location.hostname + "/update-password" ){
            setContinueUrl( login_referrer );
          } else {
            setContinueUrl( "/" );
          }
        }
      } else {
        errorContainer.innerHTML = response.data.message;
        errorContainer.style.display = "block";
      }
    });
  }

  if (loading) {
    return null;
  }

  return (
    <div className='sgl-content-wrapper forgotPasswordformcss'>
      <div className='sgl-plugin'>
        <div className='forgot_password_header'>
          <h1>Strengthen Your Security: Update Your Password</h1>
        </div>

        {/* form start */}
        <div id='sgl-plugin-form' style={{ display: "block" }}>
          <div className='div-responsive'>
            <div className='forgot-password-container'>
              <div className='fp_message'>
                <div>
                    <p>Your security is our top priority! We’ve noticed that your current password may not meet the latest security standards. A strong password helps protect your account from unauthorized access and keeps your personal information safe.</p>
                    
                    <h3 style={{ color: '#555' }}>Tips for Creating a Strong Password:</h3>
                    <ul>
                        <li><strong>Use a Mix of Characters:</strong> Include uppercase and lowercase letters, numbers, and symbols.</li>
                        <li><strong>Make It Lengthy:</strong> Aim for at least 8 characters.</li>
                        <li><strong>Avoid Common Words:</strong> Steer clear of easily guessable information like birthdays or common phrases.</li>
                    </ul>
                </div>
              </div>

              <div className='full'>
                <input
                  type='password'
                  placeholder='Password'
                  id='pass'
                  name='pass'
                  onChange={handlePasswordChange}
                />
                { password && <PasswordStrengthMeter password={password} /> }
              </div>

              <div className='full'>
                <input
                  type='password'
                  placeholder='Confirm Password'
                  name='conf_pass'
                  id='conf_pass'
                  onChange={handleConfirmPasswordChange}
                />
              </div>

              <div className='error_container'>
                <div>
                  <p
                    className='error_summary reg_error_summary'
                    id='reg_error_summary'></p>
                </div>
              </div>

              <div className='full submit'>
                <a href="javascript:void(0);" id="skip_verification" onClick={skipUpdatePassword} >Skip</a>
                <input
                  style={{float:"right"}}
                  type='button'
                  id='update'
                  className='button'
                  onClick={processUpdatePassword}
                  value='Submit'
                />
                <span id='please-wait'>
                  <img src={indicator_icon} /> Verifiying...
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* form end */}

        <div id='sgl-plugin-error-message'></div>

        <div id='sgl-plugin-success-message'>
          <p>
            <b>Password Changed</b>
            <br />
            Your password has been changed successfully.
          </p>
          <input type="button" id="continue" class="button" onClick={() => {navigate( continueUrl)}} value="Continue" />
        </div>
      </div>
    </div>
  );
}
